import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import {
    map,
    take,
} from 'rxjs/operators';

import { ISettingsSaveTonerLicensingModel } from './settings-save-toner.model';
import { SettingsSaveTonerService } from './settings-save-toner.service';

@Injectable({
    providedIn: 'root',
})
export class SettingsSaveTonerLicensingEnabledGuardService implements CanActivate {

    constructor(
        private settingsSaveTonerService: SettingsSaveTonerService,
        private router: Router,
    ) { }

    public canActivate(): Observable<boolean> {
        return this.settingsSaveTonerService
            .getLicensing()
            .pipe(
                take(1),
                map((model: ISettingsSaveTonerLicensingModel) => {
                    if (model.enabled) {
                        return true;
                    }

                    this.router.navigate(['page-forbidden']);

                    return false;
                }));
    }
}
